import { render, staticRenderFns } from "./dater.vue?vue&type=template&id=1ac9a03d&scoped=true"
import script from "./dater.vue?vue&type=script&lang=js"
export * from "./dater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9a03d",
  null
  
)

export default component.exports